<a *ngIf="isReady()" tabindex="" (click)="onClick()">
    <div class="exercise-entry-block cursor-pointer" [ngClass]="getStatusClass()" appKidsRotation>{{getName()}}</div>
</a>